// WhatsGPT-specific analytics events. Kept out of the OSS events.js so the
// upstream file stays mergeable — import from here the same way.

// The HubPost Cars dealer funnel. Signup lands on account details, which is
// followed by showroom setup and then the OSS inbox setup step, so these sit
// between ONBOARDING_EVENTS' account-details and inbox-setup pairs and share
// their "Onboarding: " prefix to keep the funnel readable in one place.
export const HUBPOST_CARS_ONBOARDING_EVENTS = Object.freeze({
  ACCOUNT_DETAILS_VISITED: 'Onboarding: HubPost account details visited',
  ACCOUNT_DETAILS_COMPLETED: 'Onboarding: HubPost account details completed',
  SHOWROOM_SETUP_VISITED: 'Onboarding: HubPost showroom setup visited',
  SHOWROOM_SETUP_COMPLETED: 'Onboarding: HubPost showroom setup completed',
});
